import React, { useState, useEffect } from "react";
import { Button, Card, Col, Form, message, Row, Spin, Modal } from "antd";

import { useAuthContext } from "../../context/AuthContext";
import { API } from "../../constant";
import { getToken } from "../../helpers";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';



const LastVisit = () => {

  const [loading] = useState(false);
  const { user } = useAuthContext();
  const params = useParams();
  const { clienteId } = params;
  const [clienteData, setClienteData] = useState(null);
  const [visitData, setVisitData] = useState(null);
  const [currentVisitIndex, setCurrentVisitIndex] = useState(0); // Índice de la visita actual
  const [actualVisit, setActualVisit] = useState([])

  const navigate = useNavigate();
  const handleClientesClick = () => {
    navigate(`/clients`);
  };
  const handleNewVisitClick = (codigoCliente) => {
    navigate(`/newVisit/${codigoCliente}`);
  };
 
  const isToday = (dateString) => {
    const today = new Date();
    const date = new Date(dateString);

    return date.getDate() === today.getDate() &&
           date.getMonth() === today.getMonth() &&
           date.getFullYear() === today.getFullYear();
};

  const handleUpdateClientesClick = () => {
    navigate(`/updatevisit/${actualVisit.id}`);
  }
  useEffect(() => {
    if (!getToken()) {
      navigate('/signin');
    }
  }, [navigate]);

  const siguienteVisita = () => {
    const newIndex = currentVisitIndex - 1;
    setCurrentVisitIndex(newIndex);
    setActualVisit(visitData?.data[newIndex]);
  };

  const anteriorVisita = () => {
    const newIndex = currentVisitIndex + 1;
    setCurrentVisitIndex(newIndex);
    setActualVisit(visitData?.data[newIndex]);
  };

  const fetchVisiteData = async () => {
    const response = await fetch(`${API}/visitas?filters[cliente][id]=${clienteId}&sort[0]=id:desc&pagination[start]=0&pagination[limit]=10&populate=imagenes`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const visitData = await response.json();
    setVisitData(visitData);
    setActualVisit(visitData?.data[currentVisitIndex]);


  };

  useEffect(() => {
    const fetchClienteData = async () => {
      try {
        const response = await fetch(`${API}/clientes/${clienteId}`, {
          headers: {
            "Content-Type": "application/json",
            // set the auth token to the user's jwt
            Authorization: `Bearer ${getToken()}`,
          },
        });
        const clienteData = await response.json();
        setClienteData(clienteData);
      } catch (error) {
        console.error(error);
        message.error("Error while fetching client data!");
      }
    };
    fetchClienteData();
  }, [clienteId]);

  useEffect(() => {
    // Asegúrate de que `user` esté definido antes de llamar a `fetchClients`
    if (user !== undefined && user !== null) {
      fetchVisiteData();

    }
  }, [user]);

  if (!visitData) {
    return (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Spin size="large" tip="Cargando..." />
    </div>);
  }


  const visita = actualVisit;
  const attributes = visita?.attributes;

  const isFirstVisit = currentVisitIndex === 0;
  const isLastVisit = currentVisitIndex === visitData?.data.length - 1;

  const deleteVisit = async () => {
    try {
      const response = await fetch(`${API}/visitas/${visita.id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });

      if (response.ok) {
        message.success("Visita eliminada con éxito!");
        // Puedes navegar de regreso a otra pantalla si lo deseas
        handleClientesClick();
      } else {
        message.error("Error al eliminar la visita.");
      }
    } catch (error) {
      console.error("Error al eliminar la visita:", error);
      message.error("Error al eliminar la visita.");
    }
  };

  const handleDeleteVisit = () => {
    Modal.confirm({
      title: '¿Estás seguro?',
      content: 'Esta acción eliminará la visita y no podrá deshacerse.',
      okText: 'Sí, eliminar',
      cancelText: 'Cancelar',
      onOk: deleteVisit,
    });
  };

  return (
    <>
      <Card className="profile_page_card">
        <Form
          layout="vertical"
        >
          <Row gutter={[16, 16]} style={{ marginBottom: '20px', alignItems: 'center' }}>
            <div>
              <p><b>Cliente: {clienteData?.data.attributes.nombre}</b></p>
              <div>Clasificación comercial: {clienteData?.data.attributes.clasificacionComercial}</div>
              <div>Clasificación financiera: {clienteData?.data.attributes.clasificacionFinanciera}</div>
              <div>Ultimo pedido: {clienteData?.data.attributes.fechaUltimoPedido}</div>
              <div>Pedidos último mes: {clienteData?.data.attributes.pedidosUltimoMes}</div>
              <div>Importe último mes: {clienteData?.data.attributes.importeUltimoMes}€</div>
              <div>Cantidad pendiente de servir: {clienteData?.data.attributes.articulosPendientes}</div>
              <div>Importe pendiente de servir: {clienteData?.data.attributes.importePendiente}€</div>
            </div>
          </Row>


          {!visitData || visitData?.data.length === 0 ?
            <Row gutter={[16, 16]} style={{ marginBottom: '20px', alignItems: 'center' }}>
              <div style={{ fontSize: '2em', textAlign: 'center', width: '100%' }}>No hay visitas previas</div>
            </Row>
              : 
         <>
          <Row gutter={[16, 16]} style={{ marginBottom: '20px', alignItems: 'center' }}>

                <div>Últimas visitas:</div>
                <Col>

                  <Button
                    icon={<LeftOutlined />}
                    onClick={() => anteriorVisita()}
                    disabled={isLastVisit} // Deshabilita el botón si es la primera visita
                  />
                </Col>
                <Col>
                  {new Date(attributes?.createdAt).toLocaleDateString()}
                </Col>
                <Col>
                  <Button
                    icon={<RightOutlined />}
                    onClick={() => siguienteVisita()}
                    disabled={isFirstVisit} // Deshabilita el botón si es la última visita
                  />
                </Col>
              </Row>
            <Row gutter={[16, 16]}>
              <Col md={6} lg={6} sm={12} xs={12}>
                <span><b>Lugar:</b> {attributes?.lugar} </span>
              </Col>
              <Col md={6} lg={6} sm={12} xs={12}>
                <span><b>Tipo:</b> {attributes?.tipo}</span>
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col md={24} lg={24} sm={24} xs={24}>
                <br />{attributes?.report && <p><b>Comentarios generales de la visita:</b></p>}
                <i>"{attributes?.report}"</i>

              </Col>
              
              {attributes?.reportPersonal && <Col md={24} lg={24} sm={24} xs={24} style={{backgroundColor: 'antiquewhite', paddingBottom: '16px'}}>
                <br />{attributes?.reportPersonal && <p><b>Notas personales</b></p>}
                <i>"{attributes?.reportPersonal}"</i>

              </Col> }
            </Row>
            <Row gutter={[16, 16]}>
              <Col md={24} lg={24} sm={24} xs={24}>
                <br />
                {attributes?.marca0 && <p><b>Marcas</b></p>}
                {[0, 1, 2, 3, 4,5,6,7,8,9].map(index => {
                  const marca = attributes[`marca${index}`];
                  const pedido = attributes[`pedido${index}`];
                  const descuento = attributes[`descuento${index}`];
                  const formaPago = attributes[`formaPago${index}`];
                  const reporteMarca = attributes[`reporteMarca${index}`];
                
                  return marca && (
                    <table className="tablaVisitasMarca" key={index}>
                      <tbody>
                        <tr>
                          <td style={{ width: '43%' }}>{marca}</td>
                          <td style={{ width: '57%' }}>Pedido: {pedido}</td>
                        </tr>
                        <tr>
                          <td>Descuento: {descuento}%</td>
                          <td>Pago: {formaPago}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="2" style={{ paddingBottom: '15px' }}><i>"{reporteMarca}"</i></td>
                        </tr>
                      </tfoot>
                    </table>
                  );
                })}
              </Col>
          </Row>
          </>
        }

          <Row>
          {(() => {
            // Validaciones para acceder de forma segura a las propiedades.
            if (!visitData || !visitData.data || !visitData.data[currentVisitIndex] || !visitData.data[currentVisitIndex].attributes || !visitData.data[currentVisitIndex].attributes.imagenes) {
                return null;
            }
        
            const imagenes = visitData.data[currentVisitIndex].attributes.imagenes.data;
        
            if (!imagenes || !Array.isArray(imagenes) || imagenes.length === 0) {
                return null;
            }
        
            return (
                <div>
                    <p style={{ marginTop: '20px' }}>Fotos:</p>
                    <div style={{ marginBottom: '20px', display: 'flex', flexWrap: 'wrap' }}>
                        {imagenes.map(imagen => {
                            const imgUrl = `https://partes.teambike.com/api${imagen.attributes.url}`;
                            return (
                                <a key={imgUrl} href={imgUrl} target="_blank" rel="noopener noreferrer" style={{ marginRight: '10px' }}>
                                    <img src={imgUrl} alt="Imagen de visita" width="100" />
                                </a>
                            );
                        })}
                    </div>
                </div>
            );
        })()}
  </Row>
  <Row gutter={[16, 16]}>
  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '40px' }}>
    <Button
      style={{ marginLeft: 0 }}
      className="profile_save_btn"
      htmlType="button"
      type="primary"
      size="large"
      onClick={() => handleClientesClick()}
      ghost
    >
      Volver
    </Button>
    <Button
      style={{ marginRight: 0 }}
      className="profile_save_btn"
      htmlType="submit"
      type="primary"
      size="large"
    onClick={() => handleUpdateClientesClick(visitData.data.id)}
  >
    Modificar
  </Button>
    <Button
      style={{ marginRight: 0 }}
      className="profile_save_btn"
      htmlType="submit"
      type="primary"
      size="large"
      onClick={() => handleNewVisitClick(clienteId)}
    >
      {loading ? (
        <>
          <Spin size="small" />Nueva visita
        </>
      ) : (
        "Nueva visita"
      )}
    </Button>
  </div>
</Row>
        </Form>
      </Card >
      <Row gutter={[16, 16]}>
        <Button
          style={{ marginRight: 24, marginTop: 30, marginBottom: 24 }}
          className="profile_save_btn"
          htmlType="button"
          type="danger"
          size="large"
          onClick={handleDeleteVisit}
        >
          Eliminar visita
        </Button>
      </Row>
    </>
  );
};

export default LastVisit;